export default {
  zoneMapping: {
    background: {
      'rooftop': [0, 1, 4],
      'rooftopCollage': ['where', 'double-dutch', 'who', 'what', 'why', 'when', 'extremes', 'the-end']
    },
    chapters: {
      'who': 1,
      'where': 2,
      'what': 3,
      'why': 4,
      'when': 5,
      'extremes': 6,
      'double-dutch': 7,
      'the-end': 8
    },
    texts: {
      'who': 'who.intro',
      'where': 'where.intro',
      'double-dutch': 'double-dutch.intro',
      'what': 'what.intro',
      'when': 'when.intro',
      'extremes': 'extremes.intro',
      'the-end': 'the-end.intro',
      'why': 'why.intro'
    }
  },
  renderOrder: {
    'sprite-0_Plane.001': 1,
    'rooftop': 2,
    'rooftopCollage': 1,
    'sprite-2.5.1_Ciskei_03.001': 2,
    'sprite-missing_1_missing_1': 3,
    'sprite-missing_1.001_missing_1.001': 2,
    'sprite-missing_1.002_missing_1.002': 1,
    'sprite-7.3_SA_steden_NL': 1,
    '09_Free-Mandela_klein': 1,
    'sprite-5.1.4_A.R._5.1_Alles_Sal_reg_Kom_Waffen_SS': -1,
    'sprite-map.bopu_map.bopu': 1,
    '03_Freedom-Charter_klein': -1,
    '01_1955-Women_s-March_klein': -1,
    '05_Sisulu-after-release_klein': -1,
    '03_UDF_klein': -1
  },
  texts: {
    'who.intro': {
      intro: {
        text: 'Dear South Africans, Apartheid was brought to you by a man born in Amsterdam inspired by the legacy of a Dutch Calvinist politician and German nazi-ideology.',
        position: 'intro-who_Plane.015'
      }
    },
    'where.intro': {
      intro: {
        text: 'One nation cut into pieces',
        position: 'intro-2_Plane.006'
      }
    },
    'why.intro': {
      intro: {
        text: 'Oppression was motivated by a conviction that the black majority manipulated by communists was a threat to white privilege.',
        position: 'intro-why_Plane.018'
      }
    },
    'the-end.intro': {
      intro: {
        text: 'The release of Nelson Mandela and unbanning of the liberation movements in 1990 set into motion a process of negotiations.',
        position: 'intro-the-end_Plane.017'
      }
    },
    'extremes.intro': {
      intro: {
        text: 'tekst over inkomensverschillen met nuance middenklasse',
        position: 'intro-extremes_Plane.016'
      }
    },
    'what.intro': {
      intro: {
        text: 'Dear South Africans, Apartheid was brought to you by a man born in Amsterdam inspired by the legacy of a Dutch Calvinist politician and German nazi-ideology.',
        position: 'intro-what_Plane.008'
      }
    },
    'when.intro': {
      intro: {
        text: 'With the National Party winning the 1948 whites only elections, the system of Apartheid was launched. In the 50 years that followed repression was met by massive resistance met by more repression met by more resistance.',
        position: 'intro-when_Plane.010',
        width: 400
      }
    },
    'double-dutch.intro': {
      intro: {
        text: 'Dutch flags, street names and monuments are the symbols of a tribal kinship between the founding fathers of Apartheid and the Dutch religious right',
        position: 'intro-7_Plane.002'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/world/configuration.js